// @ts-nocheck
import * as React from "react";
import { Ic, Sidebar, Topbar, LineChart, Kpi, AppFooter } from "./common";
import { useEscapeKey } from "../components/useEscapeKey";
import { fullTimestamp, formatAuditTime } from "../components/timeFormat";
import { AuditAlertRulesModal } from "../components/AuditAlertRulesModal";

// Audit log — 감사 로그
// Platform role: who did what, when, from where. Filterable trail.

const ACTION_LABEL = {
  login_success:  { label: "로그인 성공",     color: "green",   sev: "info" },
  login_failed:   { label: "로그인 실패",     color: "rose",    sev: "warn" },
  user_invited:   { label: "사용자 초대",     color: "sky",     sev: "info" },
  permission_change:{ label: "권한 변경",     color: "amber",   sev: "warn" },
  case_create:    { label: "케이스 생성",     color: "orange",  sev: "info" },
  case_update:    { label: "케이스 수정",     color: "orange",  sev: "info" },
  case_assigned_direct: { label: "케이스 직접 배정", color: "orange",  sev: "info" },
  care_manager_org_change: { label: "케어매니저 소속 변경", color: "amber", sev: "info" },
  care_manager_retired: { label: "케어매니저 퇴직", color: "rose", sev: "warn" },
  care_manager_reinstated: { label: "케어매니저 복직", color: "green", sev: "info" },
  org_contact_transfer: { label: "기관 담당자 해제·이관", color: "amber", sev: "info" },
  org_service_create:   { label: "기관 급여 등록",        color: "sky",   sev: "info" },
  org_service_update:   { label: "기관 급여 수정",        color: "sky",   sev: "info" },
  org_service_delete:   { label: "기관 급여 삭제",        color: "amber", sev: "warn" },
  org_availability_report: { label: "기관 가용성 보고",   color: "green", sev: "info" },
  referral_sent:        { label: "서비스 의뢰 발송",      color: "sky",   sev: "info" },
  referral_responded:   { label: "서비스 의뢰 응답",      color: "green", sev: "info" },
  referral_cancelled:   { label: "서비스 의뢰 취소",      color: "amber", sev: "warn" },
  case_delete:    { label: "케이스 삭제",     color: "rose",    sev: "warn" },
  elderly_create: { label: "어르신 등록",     color: "green",   sev: "info" },
  elderly_risk_change: { label: "위험도 변경", color: "amber",   sev: "warn" },
  elderly_health_change: { label: "건강상태 변경", color: "sky", sev: "info" },
  sos_reported:   { label: "응급SOS 접수",    color: "rose",    sev: "warn" },
  medication_create: { label: "복약 추가",     color: "orange",  sev: "info" },
  medication_update: { label: "복약 변경",     color: "orange",  sev: "info" },
  medication_delete: { label: "복약 삭제",     color: "rose",    sev: "warn" },
  approval_grant: { label: "승인 처리",       color: "green",   sev: "info" },
  approval_reject:{ label: "승인 반려",       color: "amber",   sev: "info" },
  export_csv:     { label: "데이터 내보내기", color: "sky",     sev: "warn" },
  setting_change: { label: "시스템 설정 변경", color: "rose",    sev: "warn" },
  api_token_create:{ label: "API 토큰 발급",  color: "amber",   sev: "warn" },
  region_create:  { label: "권역 신설",       color: "green",   sev: "info" },
  region_update:  { label: "권역 변경",       color: "amber",   sev: "info" },
  region_delete:  { label: "권역 삭제",       color: "rose",    sev: "warn" },
  region_promote: { label: "권역 정식 승격",   color: "green",   sev: "info" },
  region_merge:   { label: "권역 병합",       color: "amber",   sev: "warn" },
  account_locked:   { label: "계정 잠금",     color: "rose",    sev: "warn" },
  account_unlocked: { label: "계정 잠금 해제", color: "amber",   sev: "info" },
  password_reset:           { label: "비밀번호 재설정 (관리자)", color: "sky",   sev: "warn" },
  password_reset_requested: { label: "비번 재설정 요청",         color: "sky",   sev: "info" },
  password_reset_completed: { label: "비번 재설정 완료",         color: "green", sev: "info" },
  audit_purge:              { label: "감사 로그 정리",           color: "gray",  sev: "info" },
  alert_rule_change:        { label: "알림 규칙 변경",            color: "amber", sev: "info" },
  org_create:     { label: "기관 등록",       color: "green",   sev: "info" },
  org_update:     { label: "기관 변경",       color: "amber",   sev: "info" },
  org_delete:     { label: "기관 삭제",       color: "rose",    sev: "warn" },
  org_merge:      { label: "기관 병합",       color: "amber",   sev: "warn" },
  account_withdrawn:   { label: "회원 탈퇴 (본인)",   color: "rose",   sev: "warn" },
  member_created:      { label: "회원 등록 (관리자)", color: "green",  sev: "info" },
  member_withdrawn:    { label: "회원 탈퇴 (관리자)", color: "rose",   sev: "warn" },
  member_reactivated:  { label: "회원 탈퇴 철회",     color: "green",  sev: "info" },
  account_anonymized:  { label: "개인정보 익명화",     color: "gray",   sev: "info" },
  inquiry_received:      { label: "문의 접수",       color: "sky",   sev: "info" },
  inquiry_status_change: { label: "문의 처리 상태 변경", color: "amber", sev: "info" },
};

const SEV_BADGE = { info: "gray", warn: "amber", crit: "rose" };

const PERIODS = [
  { key: "day",     label: "24시간" },
  { key: "week",    label: "7일" },
  { key: "month",   label: "30일" },
  { key: "quarter", label: "분기" },
  { key: "all",     label: "전체"  },
];
const PER_PAGE = 50;

// Build server query params from current filter state. Centralized so the
// CSV export link and the JSON fetch always agree on the filter set.
// role/severity는 서버사이드 필터 — 페이지 단위가 아닌 전체 결과 기준이라
// 카운트/페이지네이션이 정확해진다.
function buildAuditParams({ q, action, role, sev, period, page }) {
  const p = new URLSearchParams();
  if (q)                              p.set("q", q);
  if (action && action !== "all")     p.set("action_kind", action);
  if (role   && role   !== "all")     p.set("role", role);
  if (sev    && sev    !== "all")     p.set("severity", sev);
  if (period && period !== "all")     p.set("period", period);
  if (page > 1)                       p.set("page", String(page));
  p.set("per_page", String(PER_PAGE));
  return p;
}

// URL 쿼리에서 필터 초기값을 1회 추출 — 다른 화면이 deep-link로 진입할 때 사용.
// 알려진 키만 화이트리스트로 받음(arbitrary 키 차단).
function readInitialFilters() {
  const p = new URLSearchParams(window.location.search);
  const pageRaw = parseInt(p.get("page") || "1", 10);
  return {
    q:      p.get("q") || "",
    action: p.get("action_kind") || "all",
    role:   p.get("role")        || "all",
    sev:    p.get("severity")    || "all",
    period: p.get("period")      || "all",
    page:   Number.isFinite(pageRaw) && pageRaw > 0 ? pageRaw : 1,
  };
}

function Audit() {
  const initial = React.useMemo(readInitialFilters, []);
  const [logs, setLogs] = React.useState([]);
  const [counts, setCounts] = React.useState({ total: 0, today: 0, warn: 0, fail: 0 });
  const [pagination, setPagination] = React.useState({ page: 1, total_pages: 1, total: 0 });
  const [q, setQ] = React.useState(initial.q);
  const [action, setAction] = React.useState(initial.action);
  const [role, setRole] = React.useState(initial.role);
  const [sev, setSev] = React.useState(initial.sev);
  const [period, setPeriod] = React.useState(initial.period);
  const [page, setPage] = React.useState(initial.page);

  // 필터 변경 시 URL을 같은 쿼리로 갱신. replaceState라 history에 잡음 없음.
  // 사용자가 현재 뷰를 복사해 공유하면 동일한 필터로 진입 가능.
  // per_page는 UI에서 변경 불가능한 상수라 URL에서 제외해 깔끔하게.
  React.useEffect(() => {
    const params = buildAuditParams({ q, action, role, sev, period, page });
    params.delete("per_page");
    const qs = params.toString();
    const next = qs ? `${window.location.pathname}?${qs}` : window.location.pathname;
    if (next !== window.location.pathname + window.location.search) {
      window.history.replaceState(null, "", next);
    }
  }, [q, action, role, sev, period, page]);
  const [open, setOpen] = React.useState(null);
  // 상세 모달이 구조화 뷰 ↔ raw JSON 뷰 사이를 토글. 모달이 열릴 때 false로 리셋.
  const [showJson, setShowJson] = React.useState(false);
  React.useEffect(() => { if (!open) setShowJson(false); }, [open]);
  useEscapeKey(() => setOpen(null), !!open);
  const [showRules, setShowRules] = React.useState(false);

  // Drill-down: 모달의 값 클릭 시 해당 필터로 좁힌 뒤 모달 닫음.
  // 단일 헬퍼로 묶어 의도 명확 + 새 drill-down 추가 시 한 곳만.
  const drillDown = (filterUpdates) => {
    if ("q"      in filterUpdates) setQ(filterUpdates.q);
    if ("action" in filterUpdates) setAction(filterUpdates.action);
    if ("role"   in filterUpdates) setRole(filterUpdates.role);
    if ("sev"    in filterUpdates) setSev(filterUpdates.sev);
    setOpen(null);
  };

  // Reset to page 1 when any filter changes (avoids landing on an empty page).
  React.useEffect(() => { setPage(1); }, [q, action, role, sev, period]);

  React.useEffect(() => {
    const params = buildAuditParams({ q, action, role, sev, period, page });
    fetch(`/api/v1/audit_logs?${params.toString()}`, { credentials: "same-origin" })
      .then(r => r.json())
      .then(d => {
        setLogs(d.logs || []);
        // KPI는 모두 서버 계산값 — 사용자 필터를 그대로 반영.
        setCounts({
          total: d.counts.total,
          today: d.counts.today,
          warn:  d.counts.warn,
          fail:  d.counts.fail,
        });
        setPagination(d.pagination || { page: 1, total_pages: 1, total: 0 });
      });
  }, [q, action, role, sev, period, page]);

  // 서버사이드 필터로 전환되었으니 클라이언트 추가 필터는 없음. logs를 그대로 렌더.
  const filtered = logs;

  // Hourly trend bars derived from real timestamps (last 12 hours).
  const trend = React.useMemo(() => {
    const buckets = Array(12).fill(0);
    const now = Date.now();
    logs.forEach(l => {
      const t = new Date(l.at).getTime();
      const hoursAgo = Math.floor((now - t) / 3600000);
      if (hoursAgo >= 0 && hoursAgo < 12) buckets[11 - hoursAgo]++;
    });
    return buckets.map(b => b * 20 + 30);
  }, [logs]);

  // Per-severity 12h trend, so the warn/fail KPI sparklines reflect actual
  // recent activity instead of a baked-in shape.
  const sevTrend = React.useMemo(() => {
    const warn = Array(12).fill(0);
    const fail = Array(12).fill(0);
    const now = Date.now();
    logs.forEach(l => {
      const hoursAgo = Math.floor((now - new Date(l.at).getTime()) / 3600000);
      if (hoursAgo < 0 || hoursAgo >= 12) return;
      const idx = 11 - hoursAgo;
      if (ACTION_LABEL[l.action]?.sev === "warn") warn[idx]++;
      if (l.action === "login_failed") fail[idx]++;
    });
    return { warn, fail };
  }, [logs]);

  return (
    <div className="app" style={{height:'100vh'}}>
      <div className="shell">
        <Sidebar role="platform" active="audit"/>
        <div style={{display:'flex', flexDirection:'column', overflow:'hidden'}}>
          <Topbar title="감사 로그" sub="시스템 내 모든 주요 행위를 기록합니다 (90일 보관)"/>
          <div className="main">

            <div style={{display:'flex', alignItems:'flex-end', justifyContent:'space-between', marginBottom:18}}>
              <div>
                <div className="h1">감사 로그 (Audit Trail)</div>
                <div className="muted" style={{marginTop:4, fontSize:13}}>법정 보관: 케이스·승인·권한 변경은 5년, 일반 활동은 90일</div>
              </div>
              <div style={{display:'flex', gap:8, alignItems:'center'}}>
                <select className="select" value={period} onChange={e=>setPeriod(e.target.value)} style={{width:120}}>
                  {PERIODS.map(p => <option key={p.key} value={p.key}>{p.label}</option>)}
                </select>
                <a className="btn btn-ghost btn-md"
                  href={`/api/v1/audit_logs/export.csv?${buildAuditParams({ q, action, role, sev, period, page: 1 }).toString()}`}
                  style={{textDecoration:'none'}}>
                  {Ic.arrow} CSV 내보내기
                </a>
                <button className="btn btn-primary btn-md" onClick={()=>setShowRules(true)}
                  title="특정 감사 이벤트에 이메일 알림 규칙 관리">
                  {Ic.alert} 알림 규칙
                </button>
              </div>
            </div>

            <div style={{display:'grid', gridTemplateColumns:'repeat(4,1fr) 1.4fr', gap:14, marginBottom:18}}>
              <Kpi label="오늘 기록"     value={`${counts.today.toLocaleString()}건`}  sparkline={trend.slice(-8)}/>
              <Kpi label="누적 기록"     value={counts.total.toLocaleString()} sparkline={trend} color="var(--sky-500)"/>
              <Kpi label="주의 이벤트"   value={`${counts.warn.toLocaleString()}건`}  sparkline={sevTrend.warn} color="var(--amber-500)"/>
              <Kpi label="로그인 실패"   value={`${counts.fail.toLocaleString()}건`}  sparkline={sevTrend.fail} color="var(--rose-500)"/>
              <div className="card" style={{padding:0, overflow:'hidden'}}>
                <div style={{padding:'10px 14px', display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                  <div>
                    <div className="lbl">최근 12시간 추이</div>
                    <div style={{fontSize:11, fontWeight:700, color:'var(--ink-2)', marginTop:2}}>현재 페이지 기준 시간대별 분포</div>
                  </div>
                  <span className="badge badge-gray">{logs.length}건</span>
                </div>
                <div style={{padding:'0 8px 6px'}}>
                  <LineChart data={trend} height={48}/>
                </div>
              </div>
            </div>

            <div className="card" style={{overflow:'hidden'}}>
              <div style={{padding:'14px 22px', display:'flex', alignItems:'center', gap:10, borderBottom:'1px solid var(--border-soft)', flexWrap:'wrap'}}>
                <div className="searchbar" style={{flex:'0 0 220px'}}>{Ic.search}<input className="input" placeholder="행위자·대상·로그 ID" value={q} onChange={e=>setQ(e.target.value)}/></div>
                <select className="select" value={action} onChange={e=>setAction(e.target.value)} style={{width:170}}>
                  <option value="all">전체 행위</option>
                  {Object.entries(ACTION_LABEL).map(([k,v]) => <option key={k} value={k}>{v.label}</option>)}
                </select>
                <select className="select" value={role} onChange={e=>setRole(e.target.value)} style={{width:140}}>
                  <option value="all">전체 역할</option>
                  <option value="system_admin">시스템 관리자</option>
                  <option value="region_admin">권역 관리자</option>
                  <option value="manager">케어매니저</option>
                  <option value="agency">유관기관</option>
                  <option value="guardian">보호자</option>
                  <option value="system">시스템</option>
                </select>
                <select className="select" value={sev} onChange={e=>setSev(e.target.value)} style={{width:120}}>
                  <option value="all">중요도</option>
                  <option value="info">정보</option>
                  <option value="warn">주의</option>
                  <option value="crit">위험</option>
                </select>
                <div style={{flex:1}}/>
                <span className="muted" style={{fontSize:11.5}}>
                  {PERIODS.find(p=>p.key===period)?.label} · 필터 적용 {pagination.total.toLocaleString()}건
                </span>
              </div>
              <table className="tbl">
                <thead><tr>
                  <th style={{paddingLeft:22, width:160}}>시각</th>
                  <th style={{width:130}}>행위자</th>
                  <th style={{width:130}}>행위</th>
                  <th>대상</th>
                  <th style={{width:130}}>IP</th>
                  <th style={{width:160}}>UA</th>
                  <th style={{width:80}}>심각도</th>
                  <th style={{textAlign:'right', paddingRight:22, width:60}}></th>
                </tr></thead>
                <tbody>
                  {filtered.map(l => {
                    const ab = ACTION_LABEL[l.action] || { label: l.action, color: "gray", sev: "info" };
                    return (
                      <tr key={l.id} onClick={()=>setOpen(l)} style={{cursor:'pointer'}}>
                        <td style={{paddingLeft:22}} className="mono muted" title={fullTimestamp(l.at)}>{formatAuditTime(l.at)}</td>
                        <td><b>{l.actor}</b><div className="muted" style={{fontSize:10}}>{l.role}</div></td>
                        <td><span className={"badge badge-" + ab.color}>{ab.label}</span></td>
                        <td style={{fontSize:12}}>{l.target}<div className="muted" style={{fontSize:10.5}}>{l.meta}</div></td>
                        <td className="mono muted">{l.ip}</td>
                        <td className="muted" style={{fontSize:11}}>{l.ua}</td>
                        <td><span className={"badge badge-" + SEV_BADGE[ab.sev]}>{ab.sev === 'warn' ? '주의' : ab.sev === 'crit' ? '위험' : '정보'}</span></td>
                        <td style={{textAlign:'right', paddingRight:22}}>{Ic.more}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div style={{padding:'12px 22px', display:'flex', alignItems:'center', justifyContent:'space-between', borderTop:'1px solid var(--border-soft)'}}>
                <div className="muted" style={{fontSize:11.5}}>
                  {pagination.total.toLocaleString()}건 중 {((pagination.page-1)*pagination.per_page+1).toLocaleString()}–
                  {Math.min(pagination.page*pagination.per_page, pagination.total).toLocaleString()}
                </div>
                <div style={{display:'flex', gap:6, alignItems:'center'}}>
                  <button className="btn btn-ghost btn-sm" disabled={pagination.page <= 1}
                    onClick={()=>setPage(p => Math.max(1, p-1))}>‹ 이전</button>
                  <span className="muted mono" style={{fontSize:11.5, padding:'0 4px'}}>
                    {pagination.page} / {pagination.total_pages || 1}
                  </span>
                  <button className="btn btn-ghost btn-sm" disabled={pagination.page >= pagination.total_pages}
                    onClick={()=>setPage(p => p+1)}>다음 ›</button>
                </div>
              </div>
            </div>

          </div>
          <AppFooter/>
        </div>
      </div>

      {showRules && (
        <AuditAlertRulesModal actionLabels={ACTION_LABEL} onClose={()=>setShowRules(false)}/>
      )}

      {open && (
        <div onClick={()=>setOpen(null)} style={{position:'fixed', inset:0, background:'rgba(20,16,12,0.4)', display:'grid', placeItems:'center', zIndex:50}}>
          <div onClick={e=>e.stopPropagation()} className="card" style={{width:580, padding:0}}>
            <div style={{padding:'16px 22px', borderBottom:'1px solid var(--border-soft)', display:'flex', alignItems:'center', justifyContent:'space-between'}}>
              <div>
                <div className="h3">{ACTION_LABEL[open.action]?.label || open.action}</div>
                <div className="mono muted" style={{fontSize:11, marginTop:2}} title={fullTimestamp(open.at)}>
                  {open.id} · {fullTimestamp(open.at)}
                </div>
              </div>
              <button className="btn btn-ghost btn-sm" onClick={()=>setOpen(null)}>{Ic.close}</button>
            </div>
            {showJson ? (
              <pre style={{margin:0, padding:'18px 22px', maxHeight:'50vh', overflow:'auto',
                           background:'var(--bg-sub)', fontSize:11.5, lineHeight:1.5,
                           color:'var(--ink-1)', whiteSpace:'pre-wrap', wordBreak:'break-all'}}>
{JSON.stringify(open, null, 2)}
              </pre>
            ) : (
              <div style={{padding:22, display:'grid', gridTemplateColumns:'120px 1fr', gap:'10px 14px', fontSize:12.5}}>
                <div className="muted">행위자</div>
                <div>
                  <DrillButton onClick={()=>drillDown({ q: open.actor })}
                    title="이 행위자의 로그만 보기"><b>{open.actor}</b></DrillButton>
                  {' · '}
                  <DrillButton onClick={()=>drillDown({ role: open.role })}
                    title="이 역할만 필터">{open.role}</DrillButton>
                </div>
                <div className="muted">대상</div>
                <div>
                  {open.target && (
                    <DrillButton onClick={()=>drillDown({ q: open.target })}
                      title="이 대상의 로그만 보기">{open.target}</DrillButton>
                  )}
                </div>
                <div className="muted">행위</div>
                <div>
                  <DrillButton onClick={()=>drillDown({ action: open.action })}
                    title="이 행위만 필터">
                    <span className={"badge badge-" + (ACTION_LABEL[open.action]?.color || "gray")}>
                      {ACTION_LABEL[open.action]?.label || open.action}
                    </span>
                  </DrillButton>
                </div>
                <div className="muted">상세</div><div>{open.meta}</div>
                <div className="muted">IP 주소</div><div className="mono">{open.ip}</div>
                <div className="muted">User Agent</div><div className="muted" style={{fontSize:11.5}}>{open.ua}</div>
                <div className="muted">심각도</div>
                <div>
                  <DrillButton onClick={()=>drillDown({ sev: ACTION_LABEL[open.action]?.sev || "info" })}
                    title="이 심각도만 필터">
                    <span className={"badge badge-" + SEV_BADGE[ACTION_LABEL[open.action]?.sev || 'info']}>
                      {ACTION_LABEL[open.action]?.sev === 'warn' ? '주의' : ACTION_LABEL[open.action]?.sev === 'crit' ? '위험' : '정보'}
                    </span>
                  </DrillButton>
                </div>
              </div>
            )}
            <div style={{padding:'14px 22px', borderTop:'1px solid var(--border-soft)', display:'flex', justifyContent:'space-between', alignItems:'center', gap:8}}>
              {showJson && (
                <button className="btn btn-ghost btn-sm"
                  onClick={() => navigator.clipboard?.writeText(JSON.stringify(open, null, 2))}
                  title="JSON 전체를 클립보드에 복사">
                  복사
                </button>
              )}
              <div style={{flex:1}}/>
              <button className="btn btn-ghost btn-md" onClick={()=>setOpen(null)}>닫기</button>
              <button className="btn btn-primary btn-md" onClick={()=>setShowJson(v=>!v)}>
                {showJson ? '구조화 보기' : '전체 JSON 보기'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// 작은 inline 클릭 가능 요소 — drill-down 일관 스타일.
// underline-dotted로 "클릭하면 필터됨"을 시각적으로 암시.
function DrillButton({ onClick, title, children }) {
  return (
    <span onClick={onClick} title={title}
      style={{ cursor: 'pointer', textDecoration: 'underline dotted', textUnderlineOffset: 3 }}>
      {children}
    </span>
  );
}

export { Audit };
